var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('spinner'):_c('div',{staticClass:"wrapper crm-layout",class:[{ 'nav-open': _vm.$sidebar.showSidebar }]},[_c('side-bar',{attrs:{"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('user-menu'),_c('template',{slot:"links"},[(_vm.canGetListOfLeads)?_c('sidebar-item',{attrs:{"link":{
          name: 'Lista zamówień',
          icon: 'assignment',
          path: '/orders',
        }}}):_vm._e(),(_vm.canGetListOfUsers)?_c('sidebar-item',{attrs:{"link":{
          name: 'Użytkownicy',
          icon: 'supervisor_account',
          path: '/users',
        }}}):_vm._e(),(_vm.canCreateRole)?_c('sidebar-item',{attrs:{"link":{
          name: 'Role i uprawnienia',
          icon: 'security',
          path: '/roles',
        }}}):_vm._e()],1)],2),_c('div',{staticClass:"main-panel"},[_c('notifications'),_c('top-navbar'),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }